export default __webpack_public_path__ + "95fa28e1e8caa20ef19c0efeaf653404.twig";